import { useEffect, useState } from "react";
import "./TimeZone.css"; // import the CSS file

export default function TimeZoneCheckerModal() {
  const [showModal, setShowModal] = useState(false);
  const [userTimeZone, setUserTimeZone] = useState("");

  useEffect(() => {
    const allowedTimeZones = ["UTC", "Atlantic/Reykjavik"];
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setUserTimeZone(tz);

    if (!allowedTimeZones.includes(tz)) {
      setShowModal(true);
    }
  }, []);

  if (!showModal) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2 className="modal-title">Timezone Warning</h2>
        <p className="modal-text">
          Your system timezone is currently set to{" "}
          <strong>{userTimeZone}</strong>.
          <br />
          For best results, please switch it to{" "}
          <strong>(UTC) Coordinated Universal Time</strong> or{" "}
          <strong>(UTC+00:00) Monrovia, Reykjavik</strong>.
          <em> Refresh this page after changes.</em>
        </p>
        <div className="modal-actions">
          <button onClick={() => setShowModal(false)} className="modal-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
